import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";

// Component
import SearchForm from "../../../../component/search-form";
import { sanitizeInput } from "../../../../utils";
import CreateAndUpdateProductionOrder from "./CreateAndUpdateProductionOrder";
import ProductionOrderTable from "./ProductionOrderTable";
import useDebounce from "../../../../Hook/useDebounce";
import { getProductionRequirementList } from "../../../../redux/actions/productionOrder";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../../component/modal-popup/customeModal";
import ProductionRequirementModal from "./ProductionRequirementModal";
import StatusFilter from "../StatusFilter";

// Redux
import { useSelector, useDispatch } from "react-redux";

function ProductionIndex({updateCounter, setUpdateCounter}) {
  //constant
  const navigate = useNavigate();

  // State
  const [searchText, setSearchText] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [update, setUpdate] = useState(1);
  const [requirementModalOpen, setRequirementModalOpen] = useState(false);
  const [status, setStatus] = useState([]);
  const [allSelectedProducts, setAllSelectedProducts] = useState([]);

  const { productionOrderData, productionRequirementData } = useSelector(
    (state) => state.productionOrder
  );
  const dispatch = useDispatch();

  const debouncedHandleSearch = useDebounce(searchText, 300);

  const getProductionRequirementData = () => {
    const request = {
      onError: (error) => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={error?.message}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getProductionRequirementList(request));
  };

  useEffect(() => {
    getProductionRequirementData();
  }, [update]);

  return (
    <div className="space-y-2">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 px-6 py-4 bg-[--bg-color-50] rounded">
        <div className="space-x-4 flex items-center">
          <h4 className="text-xl leading-5 font-bold tracking-tight">
            Production Orders
          </h4>
          <SearchForm
            placeholder="Search"
            onChange={(e) => {
              const value = sanitizeInput(e.target.value);
              setSearchText(value);
            }}
            value={searchText}
          />
          <h4 className="text-[#535860] font-semibold text-sm leading-[100%]">
            Production Orders:{" "}
            {productionOrderData ? productionOrderData.totalCount : 0}
          </h4>
        </div>

        <div className="space-x-4 flex items-center justify-end">
          <StatusFilter setStatus={setStatus} status={status} />
          <button
            className="btn !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white px-4 !py-[11px] relative"
            onClick={() => setRequirementModalOpen(true)}
          >
            <span className="fa-solid fa-wand-magic-sparkles"></span>
            <div
              className={`absolute -top-2 -right-1 ${
                productionRequirementData?.length?.toString()?.length > 2
                  ? "p-1"
                  : "w-5 h-5"
              }  bg-rose-500 rounded-[10px] text-[10px] flex items-center justify-center`}
            >
              {productionRequirementData?.length
                ? productionRequirementData?.length
                : 0}
            </div>
          </button>
          <button
            className="btn ml-0 md:ml-3 !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
            onClick={() => navigate("/order/create_production_order")}
          >
            <span className={`fas fa-plus mr-2`}></span>
            New Production Order
          </button>
        </div>
      </div>
      <ProductionOrderTable
        debouncedHandleSearch={debouncedHandleSearch}
        update={update}
        setUpdate={setUpdate}
        status={status}
        updateCounter={updateCounter}
        setUpdateCounter={setUpdateCounter}
      />
      <CreateAndUpdateProductionOrder
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        update={update}
        setUpdate={setUpdate}
        allSelectedProducts={allSelectedProducts}
        setAllSelectedProducts={setAllSelectedProducts}
      />
      <ProductionRequirementModal
        requirementModalOpen={requirementModalOpen}
        setRequirementModalOpen={setRequirementModalOpen}
        allSelectedProducts={allSelectedProducts}
        setAllSelectedProducts={setAllSelectedProducts}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
      />
    </div>
  );
}

export default ProductionIndex;
